import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    marginLeft: 20,
  },
  button: {
    minWidth: 'auto',
    padding: 2,
    background: '#fff',
    borderRadius: '50%',
    transition: 'background-color, opacity .15s linear',
    '&:hover': {
      background: '#fff',
      opacity: '.8',
    },
  },
  icon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  iconActive: {
    transform: 'rotate(180deg)',
  },
  elevation1: {
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  rounded: {
    borderRadius: 0,
  },
  menuItem: {
    padding: 8,
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  outputWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 38,
    padding: 0,
    paddingRight: 5,
    background: '#fff',
    border: '1px solid #fff',
    cursor: 'pointer',
  },
  output: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: 220,
    minWidth: 220,
    width: '100%',
    marginRight: 15,
    padding: 2.5,
    [theme.breakpoints.down(theme.size.xs)]: {
      minWidth: 150,
    },
  },
  outputItem: {
    display: 'flex',
    alignItems: 'center',
    margin: 2.5,
    padding: '3px 7px',
    fontSize: 16,
    fontFamily: 'NeoSansStd',
    background: 'rgb(239, 242, 247)',
    borderRadius: 29,
    color: theme.custom.darkBlue,
    '&:last-child': {
      marginRight: 0,
    },
  },
  listItem: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 4,
    marginTop: 3,
    padding: 1,
    background: 'transparent',
  },
  closeIcon: {
    fontSize: '0.8rem',
  },
}));
